export default class Item {
  constructor(id, x = 0, y = 0) {
    this.id = id;
    this.x = x;
    this.y = y;
  }
}



// WEBPACK FOOTER //
// ./src/models/Item.js